import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { installCurrencyGainToastGate } from "@/lib/currencyToastGate";

installCurrencyGainToastGate();

// PayPal's cross-origin iframe / zoid stack can emit opaque runtime errors that the CRA
// overlay surfaces as fatal even though the page remains usable. Swallow only PayPal-specific
// script noise so real app errors still appear.
const isPaypalNoise = (message = "", filename = "") => {
  const msg = String(message || "").toLowerCase();
  const file = String(filename || "").toLowerCase();
  return (
    msg === "script error." ||
    msg.includes("zoid destroyed all components") ||
    msg.includes("paypal") ||
    file.includes("paypal.com/sdk/js") ||
    file.includes("paypalobjects.com")
  );
};

window.addEventListener("error", (e) => {
  if (isPaypalNoise(e.message, e.filename)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

window.addEventListener("unhandledrejection", (e) => {
  const reason = e.reason?.message || e.reason || "";
  if (isPaypalNoise(reason, "")) {
    e.preventDefault();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
